import { IAwsConfig } from "../models/aws";
import environmentHelper from "../utils/environmentHelper";

export const cognitoInfo: IAwsConfig = environmentHelper.getCognitoConfig();



// WEBPACK FOOTER //
// ./src/share/config/cognito.ts